var StackedChartModule = /** @class */ (function () {
    function StackedChartModule() {
    }
    return StackedChartModule;
}());
export { StackedChartModule };
